import {
  FileTextIcon,
  Pencil2Icon,
  ArchiveIcon,
  ReaderIcon,
  PaperPlaneIcon,
  ActivityLogIcon,
} from '@radix-ui/react-icons';
import type { EbookDocument, EbookWorkspace } from '@wx-weiqi/contracts';

export const ebookSteps = [
  { id: 'pages', label: '页面识别', icon: FileTextIcon, hint: '选页识别，从需要的内容开始' },
  { id: 'edit', label: '题目校对', icon: Pencil2Icon, hint: '确认棋形与要求，录入答案变化' },
  { id: 'library', label: '教材题库', icon: ArchiveIcon, hint: '查找已校对的题目，选入电子书' },
  {
    id: 'arrange',
    label: '编排与预览',
    icon: ReaderIcon,
    hint: '设置封面与顺序，检查学生看到的内容',
  },
  { id: 'publish', label: '发布电子书', icon: PaperPlaneIcon, hint: '选择班级，发布或更新内容' },
  {
    id: 'records',
    label: '学习记录',
    icon: ActivityLogIcon,
    hint: '查看每次练习，回放学生的落子过程',
  },
] as const;

export function EbookWorkflowNav({
  step,
  onStep,
  busy,
  document,
  data,
  published,
}: {
  step: string;
  onStep: (id: string) => void;
  busy: boolean;
  document: EbookDocument;
  data: EbookWorkspace;
  published: boolean;
}) {
  const done = data.questions.filter(
    (q) => q.role === 'PROBLEM' && q.faceConfirmed && (q.mode === 'MANUAL' || q.answerConfirmed),
  ).length;
  const meta = [
    `${document.pages.filter((p) => p.status === 'DONE').length} / ${document.pageCount} 页`,
    `${done} 题已完成`,
    `${data.questions.length} 道题`,
    `${data.book.questionIds.length} 题已编排`,
    published ? '已发布 · 可更新' : '尚未发布',
    '学生练习与批改',
  ];
  return (
    <nav className="ebook-workflow-strip" aria-label="电子书工作台">
      {ebookSteps.map(({ id, label, icon: Icon }, index) => (
        <button
          key={id}
          disabled={busy}
          className={id === 'records' ? 'ebook-records-entry' : undefined}
          aria-current={step === id ? 'page' : undefined}
          aria-pressed={step === id}
          onClick={() => onStep(id)}
        >
          <Icon aria-hidden="true" />
          <span>
            <strong>{label}</strong>
            <small>{meta[index]}</small>
          </span>
        </button>
      ))}
    </nav>
  );
}
